import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  Button,
  MenuItem,
  TextField,
  FormControl,
  Select,
  InputLabel
} from "@material-ui/core";

import { Row, Col } from "react-flexbox-grid/lib/index";
import SelectSearchable from "components/Select";

import { colTypeMap } from "./DownloadCommon";

const AdvancedSearchLine = props => {
  const operatorsText = [
    "contains",
    "is exactly",
    "is empty",
    "begins with",
    "ends with",
    "-",
    "does not contain",
    "is not",
    "is not empty",
    "does not begin with",
    "does not end with"
  ];

  const operatorsNumeric = [
    "=",
    "<",
    ">",
    "<=",
    ">=",
    "!=",
    "is empty",
    "is not empty"
  ];
  const operatorsBool = [
    "is true",
    "is false",
    "is empty",
    "-",
    "is not true",
    "is not false",
    "is not empty"
  ];
  const dateFormat = "YYYY-MM-DD";
  const isADate = str => moment(str, dateFormat, true).isValid();
  const isValuelessOperator = operator =>
    ["is empty", "is not empty"].includes(operator);

  return (
    <Row style={{ marginLeft: 4, marginTop: 8 }}>
      <Col xs={12}>
        {/* <DatePicker type="date" /> */}
        {props.advancedFilters.map((filter, index) => {
          let valueEditor;
          let colProps = { datatype: "text" };
          if (props.sampleMetaData[filter.col]) {
            colProps = props.sampleMetaData[filter.col];
          }
          const inputType = colTypeMap.has(colProps.type)
            ? colTypeMap.get(colProps.type)
            : "text";
          let operators;
          switch (inputType) {
            case "date":
              operators = operatorsNumeric;
              valueEditor = (
                <TextField
                  fullWidth
                  type="date"
                  name={`datefield${index}`}
                  // eslint-disable-next-line
                  key={`datefield${index}`}
                  disabled={
                    filter.col === "" || isValuelessOperator(filter.operator)
                  }
                  value={filter.value || ""}
                  floatingLabelFixed
                  onKeyDown={e =>
                    e.keyCode === 13 && props.onAdvSaveFilter(index)
                  }
                  onChange={e => {
                    props.onAdvValueChange(index, e.target.value);
                  }}
                />
              );
              break;
            case "bool":
              operators = operatorsBool;
              valueEditor = (
                <TextField
                  style={{ marginBottom: "10px" }}
                  // eslint-disable-next-line
                  key={`disabledBool${index}`}
                  fullWidth
                  disabled
                />
              );
              break;
            case "text":
              operators = operatorsText;
              valueEditor = (
                <TextField
                  style={{ marginBottom: "10px" }}
                  disabled={
                    filter.col === "" || isValuelessOperator(filter.operator)
                  }
                  name={`${filter.col}0`}
                  key={`${filter.col}0`}
                  fullWidth
                  value={
                    isValuelessOperator(filter.operator) ? "" : filter.value
                  }
                  onKeyDown={e =>
                    e.keyCode === 13 && props.onAdvSaveFilter(index)
                  }
                  onChange={e => props.onAdvValueChange(index, e.target.value)}
                />
              );
              break;
            case "number":
              operators = operatorsNumeric;
              valueEditor = (
                <TextField
                  style={{ marginBottom: "10px" }}
                  disabled={
                    filter.col === "" || isValuelessOperator(filter.operator)
                  }
                  name={`${filter.col}0`}
                  key={`${filter.col}0-key`}
                  fullWidth
                  type={inputType}
                  onKeyDown={e =>
                    e.keyCode === 13 && props.onAdvSaveFilter(index)
                  }
                  value={
                    isValuelessOperator(filter.operator) ? "" : filter.value
                  }
                  onChange={e => props.onAdvValueChange(index, e.target.value)}
                />
              );
              break;
            default:
          }

          const options = props.columnNames.sort().map(dbName => ({
            value: dbName,
            label:
              (props.displayColumns.has(dbName) &&
                props.displayColumns.get(dbName).display_column) ||
              dbName
          }));

          return (
            // eslint-disable-next-line
            <Row bottom="xs" key={index}>
              <Col xs={4}>
                <SelectSearchable
                  value={filter.col}
                  options={options}
                  label="Field"
                  onChange={e => props.onAdvColChange(index, e.value)}
                />
              </Col>
              <Col xs={3}>
                <FormControl fullWidth style={{ marginBottom: "10px" }}>
                  <InputLabel>Select operator</InputLabel>
                  <Select
                    value={filter.operator}
                    fullWidth
                    disabled={filter.col === ""}
                    onChange={e => {
                      props.onAdvOperatorChange(index, e.target.value);
                    }}
                  >
                    {operators.map((op, i) =>
                      op === "-" ? (
                        <MenuItem
                          // eslint-disable-next-line
                          key={`break${index}${i}`}
                          value="break"
                          disabled
                          style={{
                            height: "10px",
                            minHeight: "10px"
                          }}
                        >
                          <hr />
                        </MenuItem>
                      ) : (
                        <MenuItem key={op} value={op}>
                          {op}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Col>
              <Col xs={3}>{valueEditor}</Col>
              <Col xs={2}>
                <Button
                  style={{
                    width: "30px",
                    minWidth: "30px"
                  }}
                  disabled={
                    filter.saved ||
                    !filter.col ||
                    !filter.operator ||
                    (inputType === "text" &&
                      !filter.value.length &&
                      !isValuelessOperator(filter.operator)) ||
                    (inputType === "number" &&
                      (Number.isNaN(filter.value) || !filter.value) &&
                      !isValuelessOperator(filter.operator)) ||
                    (inputType === "date" &&
                      !isADate(filter.value) &&
                      !isValuelessOperator(filter.operator))
                  }
                  onClick={() => {
                    props.onAdvSaveFilter(index);
                    setTimeout(() => props.addColumnToView(filter.col), 500);
                  }}
                >
                  <b>&#10003;</b>
                </Button>
                <Button
                  style={{
                    width: "30px",
                    minWidth: "30px"
                  }}
                  onClick={() => {
                    props.removeColumnFromView(filter.col);
                    props.onAdvRemoveFilter(index);
                  }}
                >
                  x
                </Button>

                <Button
                  style={{
                    width: "30px",
                    minWidth: "30px"
                  }}
                  onClick={() => props.actions.advAdd()}
                >
                  <b>+</b>
                </Button>
              </Col>
            </Row>
          );
        })}
      </Col>
    </Row>
  );
};
AdvancedSearchLine.propTypes = {
  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  displayColumns: PropTypes.object.isRequired,
  removeColumnFromView: PropTypes.func.isRequired,
  onAdvRemoveFilter: PropTypes.func.isRequired,
  onAdvSaveFilter: PropTypes.func.isRequired,
  onAdvOperatorChange: PropTypes.func.isRequired,
  onAdvValueChange: PropTypes.func.isRequired,
  addColumnToView: PropTypes.func.isRequired,
  onAdvColChange: PropTypes.func.isRequired,
  actions: PropTypes.shape({ advAdd: PropTypes.func.isRequired }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sampleMetaData: PropTypes.object.isRequired,
  advancedFilters: PropTypes.arrayOf(
    PropTypes.shape({
      operator: PropTypes.string,
      value: PropTypes.string,
      col: PropTypes.string
    })
  )
};
AdvancedSearchLine.defaultProps = {
  advancedFilters: [{ operator: "", value: "", col: "", saved: false }]
};

export default AdvancedSearchLine;
